import {
  Stack
} from "@mui/material";
import { styled } from "@mui/material/styles";

export const DeleteContentModalBox = styled(Stack)(({ theme }) => ({
  alignItems:"center",
  background: theme.customColors.backgroundCard,
  borderRadius:"8px",
  flexDirection: "column",
  gap: "24px",
  maxHeight:"calc(100% - 32px)",
  overflowX: "hidden",
  overflowY: "auto",
  padding:"1.5rem",

  [theme.breakpoints.down("sm")]:{
    padding:" 16px 20px"
  },

  "&:hover": {
    "&::-webkit-scrollbar-thumb":{
      backgroundColor: theme.customColors.backgroundSecondary
    }
  },
  "::-webkit-scrollbar": {
    width: "0.25rem"
  },
  "::-webkit-scrollbar-thumb":{
    backgroundColor: "transparent",
    borderRadius: "8px"
  }
}));
